import React, { useState, useEffect } from "react";
import confirmDelete from "../../assets/Images/confirm delete.png";
import { ReactComponent as Cancel } from "../../assets/Icons/Cancel.svg";
import { toast } from "react-toastify";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import CustomAlert from "../../helpers/CustomAlert";
import confetti from "canvas-confetti";
import { motion } from "framer-motion";
import CachedIcon from "@mui/icons-material/Cached";
import FilterImg from "../../assets/Images/Funnel.svg";
import CustFilterModal from "../customer/CustFilterModal";
import Pagination from "../common/Pagination";
import HubFilterModal from "../CourierHub/HubFilterModal";
import FranchiseFilterModal from "../../pages/Master/FranchiseMaster/FranchiseFilterModal";
import DetailModal from "../common/DetailModal";

const defaultFilterData = {
  customerCode: "",
  gstNumber: "",
  name: "",
  status: [],
  fromDate: "",
  toDate: "",
  companyPanNumber: "",
  firstContactPersonMobileNo: "",
  emailId: "",
};

const defaultHubFilterData = {
  customerCode: "",
  gstNumber: "",
  name: "",
  status: [],
  fromDate: "",
  toDate: "",
  companyPanNumber: "",
  firstContactPersonMobileNo: "",
  emailId: "",
};

const defaultFranchiseFilterData = {
  franchiseName: "",
  franchiseCode: "",
  gstNumber: "",
  status: [],
  fromDate: "",
  toDate: "",
  companyPanNumber: "",
  primaryContactMobile: "",
};

const DeleteConfirmationUser = ({
  isOpen,
  onClose,
  editData,
  fetchUserData,
  handleClose,
  mode,
  tableDataUser,
  setFormData,
  formData,
}) => {
  const defaultfilterDate =
    formData?.userProfile === "HUB"
      ? defaultHubFilterData
      : formData?.userProfile === "FRANCHISE"
      ? defaultFranchiseFilterData
      : defaultFilterData;

  const [selectedRow, setSelectedRow] = useState({ code: "", name: "" });
  const [showFilters, setShowFilters] = useState(false);
  const [isModalOpenFilter, setIsModalOpenFilter] = useState(false);
  const [filterData, setFilterData] = useState(defaultfilterDate);
  const [loading, setLoading] = useState(false);
  const [pageDetails, setPageDetails] = useState(null);
  const [customerData, setCustomerData] = useState([]);
  const [noData, setNoData] = useState(false);
  const [auditData, setAuditData] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const [submissionError, setSubmissionError] = useState("");

  const [rowError, setRowError] = useState("");

  const [detailModal, setDetailModal] = useState(false);
  const [modalText, setModalText] = useState("");
  const [modalHeading, setModalHeading] = useState("");

  useEffect(() => {
    if (isOpen) {
      setFilterData(defaultfilterDate);
      setShowFilters(false);
      setIsModalOpenFilter(false);
      setSelectedRow({ code: "", name: "" });
      setRowError("");
      setSubmissionError("");
      setCurrentPage(1);
      setCustomerData([]);
      setNoData(false);
      setPageDetails(null);
    }
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) {
      setSelectedRow({ code: "", name: "" });
      setRowError("");
    }
  }, [isOpen]);

  const loggedInUserName = sessionStorage.getItem("username");
  const pageSize = 10;

  // useEffect(() => {
  //   if (Array.isArray(tableDataUser) && tableDataUser.length > 0) {
  //     setCustomerData(tableDataUser);
  //   }
  // }, [tableDataUser]);

  const handleReset = () => {
    setFilterData(defaultfilterDate);
  };

  const deleteUser = () => {
    const loggedInUserName = sessionStorage.getItem("username");
    const requestBody = {
      ...editData,
      username: loggedInUserName,
      status: "3",
    };

    axiosPostApi(apiList.DELETE_USER_DATA, requestBody)
      .then((response) => {
        if (response?.status === 200 && response?.data?.respCode === "00") {
          // toast.success("User deleted successfully!");
          CustomAlert({
            title: "Success",
            text: response?.data?.message || "User deleted successfully!",
            icon: "success",
            confirmButtonText: "Ok",
          });
          const canvas = document.createElement("canvas");
          canvas.style.position = "fixed";
          canvas.style.top = "0";
          canvas.style.left = "0";
          canvas.style.width = "100%";
          canvas.style.height = "100%";
          canvas.style.zIndex = "3000";
          document.body.appendChild(canvas);

          const confettiInstance = confetti.create(canvas, {
            resize: true,
            useWorker: true,
          });

          confettiInstance({
            particleCount: 250,
            spread: 100,
            origin: { y: 0.6 },
          });

          setTimeout(() => {
            document.body.removeChild(canvas);
          }, 3000);
          fetchUserData(1);
          onClose();
          handleClose();
        } else {
          CustomAlert({
            title: "Failed to delete user",
            text:
              response.data?.message ||
              "Invalid credentials. Please try again!",
            icon: "error",
            confirmButtonText: "Retry",
          });
        }
      })
      .catch((error) => {
        console.error("Error deleting user", error);
        toast.error("Failed to delete user.");
      })
      .finally(() => {
        onClose();
        handleClose();
      });
  };

  if (!isOpen) {
    return null;
  }

  const toggleFilters = () => {
    setShowFilters((prevState) => !prevState);
  };

  const handleToggle = () => {
    // toggleFilters();
    handleReset();
    setCustomerData([]);
  };

  const openModalFilter = () => {
    setIsModalOpenFilter(true);
  };

  const closeModalFilter = () => {
    setIsModalOpenFilter(false);
  };

  const UserformatFilterDisplay = (filterData) => {
    const activeFilters = [];

    if (filterData.customerCode) {
      activeFilters.push(
        `${formData?.userProfile === "HUB" ? "Hub Id:" : "LMBP Id:"}${
          filterData.customerCode
        }`,
      );
    }

    if (filterData?.franchiseCode) {
      activeFilters.push(`Franchise Id: ${filterData.franchiseCode}`);
    }

    if (filterData.name) {
      activeFilters.push(`LMBP Name: ${filterData.name}`);
    }

    if (filterData.franchiseName) {
      activeFilters.push(`Franchise Name: ${filterData.franchiseName}`);
    }

    if (filterData.gstNumber) {
      activeFilters.push(`GST No: ${filterData.gstNumber}`);
    }
    if (filterData.status && filterData.status.length > 0) {
      activeFilters.push(`Status: ${filterData.status.join(", ")}`);
    }
    if (filterData.fromDate) {
      activeFilters.push(`Start Date: ${filterData.fromDate}`);
    }
    if (filterData.toDate) {
      activeFilters.push(`End Date: ${filterData.toDate}`);
    }
    if (filterData.companyPanNumber) {
      activeFilters.push(`Comp. Pan: ${filterData.companyPanNumber}`);
    }
    if (filterData.firstContactPersonMobileNo) {
      activeFilters.push(`Mobile No: ${filterData.firstContactPersonMobileNo}`);
    }

    if (filterData.emailId) {
      activeFilters.push(`Email: ${filterData.emailId}`);
    }

    if (filterData.primaryContactMobile) {
      activeFilters.push(`Mobile No: ${filterData.primaryContactMobile}`);
    }

    if (activeFilters.length === 0) {
      return null;
    }

    const [first, ...rest] = activeFilters;
    return rest.length > 0 ? `${first} +${rest.length} more` : first;
  };

  const modifyStructure = (response) => {
    return (
      response &&
      response?.map((customer, index) => ({
        ...customer,
        id: index + 1,
        address:
          customer.address1 +
          ", " +
          customer.address2 +
          ", " +
          customer.address3 +
          ", " +
          customer.pinCode,
      }))
    );
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}-${month}-${year}`;
  };

  const fetchCustomerData = async (currentPage, filterData) => {
    setLoading(true);

    try {
      const requestBody = {
        username: loggedInUserName,
        ...filterData,
        status: filterData.status || [],
        fromDate: formatDate(filterData.fromDate),
        toDate: formatDate(filterData.toDate),
      };

      const response = await axiosPostApi(
        `${apiList.FETCH_CUSTOMER_DATA}?&pageSize=${pageSize}&pageNo=${currentPage}`,
        requestBody,
      );

      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        setLoading(false);

        setPageDetails(response?.data?.pageDetails);
        const modifiedData = modifyStructure(response?.data?.data);
        setCustomerData(modifiedData);

        if (modifiedData?.length === 0) {
          setNoData(true);
        } else {
          setNoData(false);
        }
      } else {
        setLoading(false);

        setNoData(true);
        setCustomerData([]);
      }
    } catch (error) {
      setLoading(false);

      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoading(false);
    }
  };

  const totalRecord = pageDetails === null ? 0 : pageDetails.totalRecords;

  const showFullContent = (content, key) => {
    let heading = "Address";
    let displayContent = content;
    setModalHeading(heading);
    setModalText(displayContent);
    setDetailModal(true);
  };

  const renderAddressCell = (addressValue) => {
    if (!addressValue) return "-";
    return (
      <>
        {addressValue.substring(0, 8)}...
        <div
          className="text-[#00B6CE] underline cursor-pointer"
          title="View full content"
          onClick={() => showFullContent(addressValue, "address")}
        >
          View More
        </div>
      </>
    );
  };

  return (
    <div
      className={`modal fade show ${
        mode === "delete" ? "modal-md" : "modal-xl"
      }`}
      style={{
        display: "block",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        margin: 0,
      }}
    >
      <div
        className="modal-dialog"
        style={{
          width: "90%",
          maxWidth: "90%",
          marginTop:
            mode !== "delete" && customerData.length === 0
              ? "180px"
              : undefined,
        }}
      >
        <div className="modal-content rounded-3xl">
          <div
            className="modal-header"
            style={{ borderBottom: "none", justifyContent: "end", gap: "8px" }}
          >
            {mode !== "delete" && (
              <div className="filter-container">
                {showFilters && (
                  <motion.div
                    initial={{ x: "100%", opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    exit={{ x: "100%", opacity: 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    <div className="search-btn" onClick={openModalFilter}>
                      Search/Filter
                    </div>
                  </motion.div>
                )}

                {showFilters && (
                  <motion.div
                    initial={{ x: "100%", opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    exit={{ x: "100%", opacity: 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    <div className="green-btn" onClick={handleToggle}>
                      <CachedIcon />
                    </div>
                  </motion.div>
                )}

                <div className="flex items-center whitespace-nowrap max-w-[20vw]">
                  <img
                    src={FilterImg}
                    alt="funnel"
                    className="funnel-icon"
                    onClick={toggleFilters}
                  />
                  <div
                    className={`filter-text ${
                      filterData && Object.keys(filterData).length > 0
                        ? "pr-1"
                        : ""
                    }`}
                  >
                    {filterData && UserformatFilterDisplay(filterData)}
                  </div>
                </div>
              </div>
            )}
            <span>
              <Cancel onClick={onClose} />
            </span>
          </div>
          <div className="modal-body text-center">
            {mode === "delete" ? (
              <>
                <img
                  src={confirmDelete}
                  alt="Warning"
                  className="img-fluid mb-3"
                  style={{ width: "250px" }}
                />
                <h5 className="modal-title">
                  {mode === "delete" ? "Delete Confirmation" : "Data Table"}
                </h5>
                <p className="mt-2">
                  Information will be permanently erased and irretrievable.
                </p>
              </>
            ) : (
              <>
                <div className="w-full bg-white rounded-xl shadow-md border border-gray-100 overflow-hidden">
                  <div className="overflow-x-auto max-h-[60vh] custom-scrollbar">
                    {formData?.userProfile === "Franchise" ? (
                      <table className="w-full text-sm text-gray-700">
                        <thead className="sticky top-0 z-10 !bg-[#ffe8d4] shadow-sm">
                          <tr>
                            <th className="px-3 py-3 text-sm font-bold text-[#2e237f] tracking-wide text-center whitespace-nowrap"></th>
                            <th className="px-3 py-3 text-sm font-bold text-[#2e237f] tracking-wide whitespace-nowrap">
                              Franchise Id
                            </th>
                            <th className="px-3 py-3 text-sm font-bold text-[#2e237f] tracking-wide whitespace-nowrap">
                              Franchise Name
                            </th>
                            <th className="px-3 py-3 text-sm font-bold text-[#2e237f] tracking-wide whitespace-nowrap">
                              Status
                            </th>
                            <th className="px-3 py-3 text-sm font-bold text-[#2e237f] tracking-wide whitespace-nowrap">
                              Remark
                            </th>
                            <th className="px-3 py-3 text-sm font-bold text-[#2e237f] tracking-wide whitespace-nowrap">
                              Franchise Email Id
                            </th>
                            <th className="px-3 py-3 text-sm font-bold text-[#2e237f] tracking-wide whitespace-nowrap">
                              Address
                            </th>
                            <th className="px-3 py-3 text-sm font-bold text-[#2e237f] tracking-wide whitespace-nowrap">
                              Contact Person <br /> Name
                            </th>
                            <th className="px-3 py-3 text-sm font-bold text-[#2e237f] tracking-wide whitespace-nowrap">
                              Contact Person <br /> Mobile No
                            </th>
                            <th className="px-3 py-3 text-sm font-bold text-[#2e237f] tracking-wide whitespace-nowrap">
                              GST Number
                            </th>
                            <th className="px-3 py-3 text-sm font-bold text-[#2e237f] tracking-wide whitespace-nowrap">
                              Franchise Pan
                            </th>
                            <th className="px-3 py-3 text-sm font-bold text-[#2e237f] tracking-wide whitespace-nowrap">
                              Aadhar Number
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {customerData && customerData.length > 0 ? (
                            customerData.map((row, index) => {
                              const currentCode = row.franchiseCode;

                              return (
                                <React.Fragment key={index}>
                                  <tr className="border-b hover:bg-orange-50 transition duration-200">
                                    <td className="px-4 py-3 text-center">
                                      <input
                                        type="radio"
                                        name="selectRow"
                                        onChange={() => {
                                          const selectedCode = currentCode;
                                          const selectedName =
                                            row.franchiseName;

                                          setSelectedRow({
                                            code: selectedCode,
                                            name: selectedName,
                                          });

                                          if (row.authStatus === "IN-ACTIVE") {
                                            setRowError(
                                              "Unable to create user: The selected LMBP is inactive. Please activate it to proceed.",
                                            );
                                          } else {
                                            setRowError("");
                                          }
                                        }}
                                        checked={
                                          selectedRow.code === currentCode
                                        }
                                      />
                                    </td>
                                    <td className="px-4 py-3 whitespace-nowrap text-sm">
                                      {row?.franchiseCode}
                                    </td>
                                    <td className="px-4 py-3 whitespace-nowrap text-sm">
                                      {row?.franchiseName}
                                    </td>
                                    <td className="px-4 py-3 whitespace-nowrap text-sm">
                                      {row?.authStatus}
                                    </td>
                                    <td className="px-4 py-3 whitespace-nowrap text-sm">
                                      {row?.adminRemark}
                                    </td>
                                    <td className="px-4 py-3 whitespace-nowrap text-sm">
                                      {row?.emailId}
                                    </td>
                                    <td className="px-4 py-3 whitespace-nowrap text-sm">
                                      {renderAddressCell(
                                        row?.addr1 +
                                          ", " +
                                          row?.addr2 +
                                          ", " +
                                          row?.addr3 +
                                          ", " +
                                          row?.pinCode,
                                      )}
                                    </td>
                                    <td className="px-4 py-3 whitespace-nowrap text-sm">
                                      {row?.primaryContactName}
                                    </td>
                                    <td className="px-4 py-3 whitespace-nowrap text-sm">
                                      {row?.primaryContactMobile}
                                    </td>
                                    <td className="px-4 py-3 whitespace-nowrap text-sm">
                                      {row?.gstNumber}
                                    </td>
                                    <td className="px-4 py-3 whitespace-nowrap text-sm">
                                      {row?.panNumber}
                                    </td>
                                    <td className="px-4 py-3 whitespace-nowrap text-sm">
                                      {row?.aadharNumber}
                                    </td>
                                  </tr>

                                  {rowError &&
                                    selectedRow.code === currentCode && (
                                      <tr>
                                        <td colSpan="12">
                                          <div
                                            className="alert alert-danger text-start"
                                            role="alert"
                                            style={{ margin: 0 }}
                                          >
                                            {rowError}
                                          </div>
                                        </td>
                                      </tr>
                                    )}
                                </React.Fragment>
                              );
                            })
                          ) : (
                            <tr>
                              <td
                                colSpan="12"
                                className="px-4 py-6 text-start font-semibold text-gray-500"
                              >
                                {Object.values(filterData || {}).some((value) =>
                                  Array.isArray(value)
                                    ? value.length > 0
                                    : value !== "",
                                )
                                  ? "No data available"
                                  : "Use filter options to search and display data"}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    ) : formData?.userProfile === "HUB" ? (
                      <table className="w-full text-sm text-gray-700">
                        <thead className="sticky top-0 z-10 !bg-[#ffe8d4] shadow-sm">
                          <tr>
                            <th className="px-3 py-3 text-sm font-bold text-[#2e237f] tracking-wide text-center whitespace-nowrap"></th>
                            <th className="px-3 py-3 text-sm font-bold text-[#2e237f] tracking-wide whitespace-nowrap">
                              Hub Id
                            </th>
                            <th className="px-3 py-3 text-sm font-bold text-[#2e237f] tracking-wide whitespace-nowrap">
                              Hub Name
                            </th>
                            <th className="px-3 py-3 text-sm font-bold text-[#2e237f] tracking-wide whitespace-nowrap">
                              Status
                            </th>
                            <th className="px-3 py-3 text-sm font-bold text-[#2e237f] tracking-wide whitespace-nowrap">
                              Remark
                            </th>
                            <th className="px-3 py-3 text-sm font-bold text-[#2e237f] tracking-wide whitespace-nowrap">
                              Hub Email Id
                            </th>
                            <th className="px-3 py-3 text-sm font-bold text-[#2e237f] tracking-wide whitespace-nowrap">
                              Address
                            </th>
                            <th className="px-3 py-3 text-sm font-bold text-[#2e237f] tracking-wide whitespace-nowrap">
                              Contact Person <br />
                              Name
                            </th>
                            <th className="px-3 py-3 text-sm font-bold text-[#2e237f] tracking-wide whitespace-nowrap">
                              Contact Person <br /> Mobile No
                            </th>
                            <th className="px-3 py-3 text-sm font-bold text-[#2e237f] tracking-wide whitespace-nowrap">
                              GST Number
                            </th>
                            <th className="px-3 py-3 text-sm font-bold text-[#2e237f] tracking-wide whitespace-nowrap">
                              Hub Pan
                            </th>
                            <th className="px-3 py-3 text-sm font-bold text-[#2e237f] tracking-wide whitespace-nowrap">
                              Aadhar Number
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {customerData && customerData.length > 0 ? (
                            customerData.map((row, index) => {
                              const currentCode = row.hubCode;

                              return (
                                <React.Fragment key={index}>
                                  <tr className="border-b hover:bg-orange-50 transition duration-200">
                                    <td className="px-4 py-3 text-center">
                                      <input
                                        type="radio"
                                        name="selectRow"
                                        onChange={() => {
                                          const selectedCode = currentCode;
                                          const selectedName = row.hubName;

                                          setSelectedRow({
                                            code: selectedCode,
                                            name: selectedName,
                                          });

                                          if (row.authStatus === "IN-ACTIVE") {
                                            setRowError(
                                              "Unable to create user: The selected LMBP is inactive. Please activate it to proceed.",
                                            );
                                          } else {
                                            setRowError("");
                                          }
                                        }}
                                        checked={
                                          selectedRow.code === currentCode
                                        }
                                      />
                                    </td>
                                    <td className="px-4 py-3 whitespace-nowrap text-sm">
                                      {row?.hubCode}
                                    </td>
                                    <td className="px-4 py-3 whitespace-nowrap text-sm">
                                      {row?.hubName}
                                    </td>
                                    <td className="px-4 py-3 whitespace-nowrap text-sm">
                                      {row?.authStatus}
                                    </td>
                                    <td className="px-4 py-3 whitespace-nowrap text-sm">
                                      {row?.adminRemark}
                                    </td>
                                    <td className="px-4 py-3 whitespace-nowrap text-sm">
                                      {row?.hubEmailId}
                                    </td>
                                    <td className="px-4 py-3 whitespace-nowrap text-sm">
                                      {renderAddressCell(row?.address)}
                                    </td>
                                    <td className="px-4 py-3 whitespace-nowrap text-sm">
                                      {row?.contactPersonName}
                                    </td>
                                    <td className="px-4 py-3 whitespace-nowrap text-sm">
                                      {row?.contactPersonMobileNo}
                                    </td>
                                    <td className="px-4 py-3 whitespace-nowrap text-sm">
                                      {row?.gstNumber}
                                    </td>
                                    <td className="px-4 py-3 whitespace-nowrap text-sm">
                                      {row?.panNumber}
                                    </td>
                                    <td className="px-4 py-3 whitespace-nowrap text-sm">
                                      {row?.aadharNumber}
                                    </td>
                                  </tr>

                                  {rowError &&
                                    selectedRow.code === currentCode && (
                                      <tr>
                                        <td colSpan="12">
                                          <div
                                            className="alert alert-danger text-start"
                                            role="alert"
                                            style={{ margin: 0 }}
                                          >
                                            {rowError}
                                          </div>
                                        </td>
                                      </tr>
                                    )}
                                </React.Fragment>
                              );
                            })
                          ) : (
                            <tr>
                              <td
                                colSpan="12"
                                className="px-4 py-6 text-start font-semibold text-gray-500"
                              >
                                {Object.values(filterData || {}).some((value) =>
                                  Array.isArray(value)
                                    ? value.length > 0
                                    : value !== "",
                                )
                                  ? "No data available"
                                  : "Use filter options to search and display data"}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    ) : (
                      <table className="w-full text-sm text-gray-700">
                        <thead className="sticky top-0 z-10 !bg-[#ffe8d4] shadow-sm">
                          <tr>
                            <th className="px-3 py-3 text-sm font-bold text-[#2e237f] tracking-wide text-center whitespace-nowrap"></th>
                            <th className="px-3 py-3 text-sm font-bold text-[#2e237f] tracking-wide whitespace-nowrap">
                              LMBP Id
                            </th>
                            <th className="px-3 py-3 text-sm font-bold text-[#2e237f] tracking-wide whitespace-nowrap">
                              LMBP Name
                            </th>
                            <th className="px-3 py-3 text-sm font-bold text-[#2e237f] tracking-wide whitespace-nowrap">
                              Hierarchy Type
                            </th>
                            <th className="px-3 py-3 text-sm font-bold text-[#2e237f] tracking-wide whitespace-nowrap">
                              Status
                            </th>
                            <th className="px-3 py-3 text-sm font-bold text-[#2e237f] tracking-wide whitespace-nowrap">
                              Remark
                            </th>
                            <th className="px-3 py-3 text-sm font-bold text-[#2e237f] tracking-wide whitespace-nowrap">
                              LMBP Email Id
                            </th>
                            <th className="px-3 py-3 text-sm font-bold text-[#2e237f] tracking-wide whitespace-nowrap">
                              Address
                            </th>
                            <th className="px-3 py-3 text-sm font-bold text-[#2e237f] tracking-wide whitespace-nowrap">
                              Contact Person <br />
                              Name
                            </th>
                            <th className="px-3 py-3 text-sm font-bold text-[#2e237f] tracking-wide whitespace-nowrap">
                              Contact Person <br />
                              Mobile No
                            </th>
                            <th className="px-3 py-3 text-sm font-bold text-[#2e237f] tracking-wide whitespace-nowrap">
                              GST Number
                            </th>
                            <th className="px-3 py-3 text-sm font-bold text-[#2e237f] tracking-wide whitespace-nowrap">
                              LMBP Pan
                            </th>
                            <th className="px-3 py-3 text-sm font-bold text-[#2e237f] tracking-wide whitespace-nowrap">
                              Contact Person <br />
                              PAN Number
                            </th>
                            <th className="px-3 py-3 text-sm font-bold text-[#2e237f] tracking-wide whitespace-nowrap">
                              Contact Person <br />
                              Aadhar Number
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {customerData && customerData.length > 0 ? (
                            customerData.map((row, index) => {
                              const currentCode =
                                row.customerCode ||
                                row.vendorId ||
                                row.retailerCode;

                              return (
                                <React.Fragment key={index}>
                                  <tr className="border-b hover:bg-orange-50 transition duration-200">
                                    <td className="px-4 py-3 text-center">
                                      <input
                                        type="radio"
                                        name="selectRow"
                                        onChange={() => {
                                          const selectedCode = currentCode;
                                          const selectedName =
                                            row.name || row.vendorName;

                                          setSelectedRow({
                                            code: selectedCode,
                                            name: selectedName,
                                          });

                                          if (row.authStatus === "IN-ACTIVE") {
                                            setRowError(
                                              "Unable to create user: The selected LMBP is inactive. Please activate it to proceed.",
                                            );
                                          } else {
                                            setRowError("");
                                          }
                                        }}
                                        checked={
                                          selectedRow.code === currentCode
                                        }
                                      />
                                    </td>
                                    <td className="px-4 py-3 whitespace-nowrap text-sm">
                                      {row?.customerCode}
                                    </td>
                                    <td className="px-4 py-3 whitespace-nowrap text-sm">
                                      {row?.name}
                                    </td>
                                    <td className="px-4 py-3 whitespace-nowrap text-sm">
                                      {row?.hierarchyType}
                                    </td>
                                    <td className="px-4 py-3 whitespace-nowrap text-sm">
                                      {row?.authStatus}
                                    </td>
                                    <td className="px-4 py-3 whitespace-nowrap text-sm">
                                      {row?.adminRemark}
                                    </td>
                                    <td className="px-4 py-3 whitespace-nowrap text-sm">
                                      {row?.emailId}
                                    </td>
                                    <td className="px-4 py-3 whitespace-nowrap text-sm">
                                      {renderAddressCell(row?.address)}
                                    </td>
                                    <td className="px-4 py-3 whitespace-nowrap text-sm">
                                      {row?.firstContactPersonName}
                                    </td>
                                    <td className="px-4 py-3 whitespace-nowrap text-sm">
                                      {row?.firstContactPersonMobileNo}
                                    </td>
                                    <td className="px-4 py-3 whitespace-nowrap text-sm">
                                      {row?.gstNumber}
                                    </td>
                                    <td className="px-4 py-3 whitespace-nowrap text-sm">
                                      {row?.companyPanNumber}
                                    </td>
                                    <td className="px-4 py-3 whitespace-nowrap text-sm">
                                      {row?.panNumber}
                                    </td>
                                    <td className="px-4 py-3 whitespace-nowrap text-sm">
                                      {row?.aadharNumber}
                                    </td>
                                  </tr>

                                  {rowError &&
                                    selectedRow.code === currentCode && (
                                      <tr>
                                        <td colSpan="13">
                                          <div
                                            className="alert alert-danger text-start"
                                            role="alert"
                                            style={{ margin: 0 }}
                                          >
                                            {rowError}
                                          </div>
                                        </td>
                                      </tr>
                                    )}
                                </React.Fragment>
                              );
                            })
                          ) : (
                            <tr>
                              <td
                                colSpan="13"
                                className="px-4 py-6 text-start font-semibold text-gray-500"
                              >
                                {Object.values(filterData || {}).some((value) =>
                                  Array.isArray(value)
                                    ? value.length > 0
                                    : value !== "",
                                )
                                  ? "No data available"
                                  : "Use filter options to search and display data"}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              </>
            )}

            {mode !== "delete" && totalRecord > 10 && (
              <div className="d-flex justify-content-center mt-3">
                <Pagination
                  currentPage={currentPage}
                  totalCount={totalRecord}
                  pageSize={pageSize}
                  onPageChange={(page) => {
                    setCurrentPage(page);
                    fetchCustomerData(page, filterData);
                  }}
                />
              </div>
            )}
          </div>
          <div className="modal-footer justify-content-center border-t-0">
            <button
              type="button"
              className="btn btn-back w-[133px] !rounded-lg"
              data-bs-dismiss="modal"
              onClick={() => {
                onClose();
                handleReset();
                setCustomerData([]);
                setPageDetails(null);
                setSelectedRow({ code: "", name: "" }); // ⬅ reset selection
                setRowError(""); // ⬅ clear error if any
              }}
            >
              Cancel
            </button>

            {mode === "delete" ? (
              <button
                type="button"
                className="btn btn-danger w-[133px] !rounded-lg"
                onClick={deleteUser}
              >
                Delete Permanently
              </button>
            ) : (
              // <button
              //   type="button"
              //   className="btn btn-submit"
              //   onClick={() => {
              //     setFormData({
              //       ...formData,
              //       userCode: selectedRow.code,
              //       selectedName: selectedRow.name,
              //     });
              //     onClose();
              //   }}
              // >
              //   Submit
              // </button>

              <button
                type="button"
                className="btn btn-submit w-[133px] !rounded-lg"
                onClick={() => {
                  const selectedCompany = customerData.find(
                    (row) =>
                      selectedRow.code ===
                      (row.customerCode || row.vendorId || row.retailerCode),
                  );

                  if (selectedCompany?.authStatus === "IN-ACTIVE") {
                    setSubmissionError(
                      "Unable to create user: The selected LMBP is inactive. Please activate it to proceed.",
                    );
                    return;
                  }

                  if (formData?.userProfile === "HUB") {
                    setFormData({
                      ...formData,
                      hubCode: selectedRow.code,
                      selectedHubName: selectedRow.name,
                    });
                  } else {
                    // Pre-fill the user's details from the selected LMBP's
                    // primary contact; keep anything already typed if the
                    // LMBP record lacks that field.
                    setFormData({
                      ...formData,
                      userCode: selectedRow.code,
                      selectedName: selectedRow.name,
                      name:
                        selectedCompany?.firstContactPersonName ||
                        selectedCompany?.name ||
                        formData?.name,
                      mobileNo:
                        selectedCompany?.firstContactPersonMobileNo ||
                        formData?.mobileNo,
                      emailId: selectedCompany?.emailId || formData?.emailId,
                    });
                  }

                  setSubmissionError(""); // Clear error if previously shown
                  onClose();
                }}
              >
                Submit
              </button>
            )}
          </div>
        </div>
      </div>
      {isModalOpenFilter &&
        formData?.userProfile !== "HUB" &&
        formData?.userProfile !== "Franchise" && (
          <CustFilterModal
            show={isModalOpenFilter}
            handleClose={closeModalFilter}
            auditData={auditData}
            setCustomerData={setCustomerData}
            setPageDetails={setPageDetails}
            setNoData={setNoData}
            currentPage={currentPage}
            pageSize={pageSize}
            filterData={filterData}
            setFilterData={setFilterData}
            handleReset={handleReset}
            text="AddUser"
          />
        )}

      {isModalOpenFilter && formData?.userProfile === "HUB" && (
        <HubFilterModal
          show={isModalOpenFilter}
          handleClose={closeModalFilter}
          auditData={auditData}
          setCustomerData={setCustomerData}
          setPageDetails={setPageDetails}
          setNoData={setNoData}
          currentPage={currentPage}
          pageSize={pageSize}
          filterData={filterData}
          setFilterData={setFilterData}
          handleReset={handleReset}
          text="AddUser"
        />
      )}

      {isModalOpenFilter && formData?.userProfile === "Franchise" && (
        <FranchiseFilterModal
          show={isModalOpenFilter}
          handleClose={closeModalFilter}
          auditData={auditData}
          setCustomerData={setCustomerData}
          setPageDetails={setPageDetails}
          setNoData={setNoData}
          currentPage={currentPage}
          pageSize={pageSize}
          filterData={filterData}
          setFilterData={setFilterData}
          handleReset={handleReset}
          text="AddUser"
        />
      )}

      <DetailModal
        open={detailModal}
        onClose={() => setDetailModal(false)}
        text={modalText}
        headingText={modalHeading || "Details"}
      />
    </div>
  );
};

export default DeleteConfirmationUser;
